const adminRoot = document.querySelector("[data-admin-root]");

function initAdminHomeContent() {
  const store = window.NMHomeContent;
  if (!store || !adminRoot || window.NMAdminHomeContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');
  const homeDescForm = document.querySelector("[data-home-desc-form]");
  const homeDescNote = document.querySelector("[data-home-desc-note]");
  const homeAchievementsForm = document.querySelector("[data-home-achievements-form]");
  const homeAchievementsNote = document.querySelector("[data-home-achievements-note]");
  const homeClientsTitleForm = document.querySelector("[data-home-clients-title-form]");
  const homeClientsTitleNote = document.querySelector("[data-home-clients-title-note]");
  const homeClientsTitleInput = document.querySelector("[data-home-clients-title-input]");
  const clientsList = document.querySelector("[data-clients-list]");
  const clientsCount = document.querySelector("[data-clients-count]");
  const clientsCreateBtn = document.querySelector("[data-clients-create]");
  const clientsModal = document.querySelector("[data-clients-modal]");
  const clientsForm = document.querySelector("[data-clients-form]");
  const clientsFormTitle = document.querySelector("[data-clients-form-title]");
  const clientsImageInput = document.querySelector("#clients-image");
  const clientsImageData = document.querySelector("[data-clients-image-data]");
  const clientsImagePreview = document.querySelector("[data-clients-image-preview]");
  const clientsImageReset = document.querySelector("[data-clients-image-reset]");
  const heroList = document.querySelector("[data-hero-list]");
  const heroCount = document.querySelector("[data-hero-count]");
  const heroCreateBtn = document.querySelector("[data-hero-create]");
  const heroModal = document.querySelector("[data-hero-modal]");
  const heroForm = document.querySelector("[data-hero-form]");
  const heroFormTitle = document.querySelector("[data-hero-form-title]");
  const heroImageInput = document.querySelector("#hero-image");
  const heroImageData = document.querySelector("[data-hero-image-data]");
  const heroImagePreview = document.querySelector("[data-hero-image-preview]");
  const heroImageReset = document.querySelector("[data-hero-image-reset]");
  const homeApproachTitleForm = document.querySelector("[data-home-approach-title-form]");
  const homeApproachTitleNote = document.querySelector("[data-home-approach-title-note]");
  const homeApproachAccentInput = document.querySelector("[data-home-approach-accent-input]");
  const homeApproachRestInput = document.querySelector("[data-home-approach-rest-input]");
  const homeApproachTitlePreview = document.querySelector("[data-home-approach-title-preview]");
  const approachList = document.querySelector("[data-approach-list]");
  const approachCount = document.querySelector("[data-approach-count]");
  const approachCreateBtn = document.querySelector("[data-approach-create]");
  const approachModal = document.querySelector("[data-approach-modal]");
  const approachForm = document.querySelector("[data-approach-form]");
  const approachFormTitle = document.querySelector("[data-approach-form-title]");
  const approachIconInput = document.querySelector("#approach-icon");
  const approachIconData = document.querySelector("[data-approach-icon-data]");
  const approachIconPreview = document.querySelector("[data-approach-icon-preview]");
  const approachIconReset = document.querySelector("[data-approach-icon-reset]");

  let editingHeroId = null;
  let editingClientId = null;
  let editingApproachId = null;
  let noteTimer = null;

  function parseStarTitle(value) {
    const raw = String(value || "").trim();
    const match = raw.match(/^\*([^*]+)\*\s*(.*)$/);
    if (match) {
      return { accent: match[1].trim(), rest: match[2].trim() };
    }
    const parts = raw.replace(/\*/g, "").split(/\s+/).filter(Boolean);
    return {
      accent: parts[0] || "",
      rest: parts.slice(1).join(" "),
    };
  }

  function buildStarTitle(accent, rest) {
    const accentPart = String(accent || "").trim();
    const restPart = String(rest || "").trim();
    if (!accentPart && !restPart) return "";
    if (!accentPart) return restPart;
    if (!restPart) return `*${accentPart}*`;
    return `*${accentPart}* ${restPart}`;
  }

  function updateApproachTitlePreview() {
    if (!homeApproachTitlePreview) return;
    const accent = String(homeApproachAccentInput?.value || "").trim() || "Наш подход";
    const rest = String(homeApproachRestInput?.value || "").trim() || "к работе";
    homeApproachTitlePreview.innerHTML = `Превью: <span>${store.escapeHtml(accent)}</span> ${store.escapeHtml(rest)}`.trim();
  }

  function showNote(node) {
    if (!node) return;
    const note = node;
    note.hidden = false;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      note.hidden = true;
    }, 2200);
  }

  function formatSymbolCount(count) {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11) return `${count} символ`;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${count} символа`;
    return `${count} символов`;
  }

  function autosizeTextarea(textarea) {
    if (!textarea) return;
    const node = textarea;
    node.style.height = "auto";
    node.style.height = `${Math.max(node.scrollHeight, node.name === "title" ? 96 : 120)}px`;
  }

  function clearHomeDescErrors() {
    homeDescForm?.querySelectorAll("[data-home-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-home-error]");
      if (error) error.hidden = true;
    });
  }

  function showHomeDescError(name) {
    const field = homeDescForm?.querySelector(`[data-home-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-home-error]");
    if (error) error.hidden = false;
  }

  function updateHomeDescFieldsUI() {
    if (!homeDescForm) return;
    homeDescForm.querySelectorAll("[data-home-input]").forEach((input) => {
      const name = input.getAttribute("data-home-input");
      const counter = homeDescForm.querySelector(`[data-home-counter="${name}"]`);
      const value = String(input.value || "");
      if (counter) counter.textContent = formatSymbolCount(value.length);
      autosizeTextarea(input);
    });
  }

  function fillHomeDescriptionForm() {
    if (!homeDescForm) return;
    const { description } = store.getHomeData();
    homeDescForm.elements.title.value = description.title || "";
    homeDescForm.elements.paragraph1.value = description.paragraph1 || "";
    homeDescForm.elements.paragraph2.value = description.paragraph2 || "";
    if (homeDescNote) homeDescNote.hidden = true;
    clearHomeDescErrors();
    updateHomeDescFieldsUI();
  }

  function fillHomeAchievementsForm() {
    if (!homeAchievementsForm) return;
    const { achievements } = store.getHomeData();
    achievements.forEach((item, index) => {
      const valueInput = homeAchievementsForm.elements[`value${index}`];
      const labelInput = homeAchievementsForm.elements[`label${index}`];
      if (valueInput) valueInput.value = item.value || "";
      if (labelInput) labelInput.value = item.label || "";
    });
    if (homeAchievementsNote) homeAchievementsNote.hidden = true;
  }

  function clearHeroErrors() {
    document.querySelectorAll("[data-hero-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-hero-error]");
      if (error) error.hidden = true;
    });
  }

  function showHeroError(name) {
    const field = document.querySelector(`[data-hero-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-hero-error]");
    if (error) error.hidden = false;
  }

  function updateHeroImagePreview(src) {
    if (!heroImagePreview) return;
    const img = heroImagePreview.querySelector("img");
    if (!src) {
      heroImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    heroImagePreview.hidden = false;
  }

  function closeHeroModal() {
    if (heroModal) heroModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingHeroId = null;
    if (heroForm) heroForm.reset();
    if (heroImageData) heroImageData.value = "";
    clearHeroErrors();
    updateHeroImagePreview("");
  }

  function openHeroModal() {
    if (!heroModal) return;
    heroModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function fillHeroForm(slide) {
    if (!heroForm) return;
    heroForm.elements.id.value = slide?.id || "";
    heroForm.elements.title.value = slide?.title || "";
    heroForm.elements.buttonText.value = slide?.buttonText || "Заказать рекламу";
    if (heroImageData) heroImageData.value = slide?.image || "";
    updateHeroImagePreview(slide?.image || store.resolveSlideImage(slide || {}, 0));
  }

  function renderHeroAdmin() {
    if (!heroList) return;
    const slides = store.getHomeData().slides || [];

    if (heroCount) {
      heroCount.textContent = slides.length
        ? `Слайдов: ${slides.length}`
        : "Слайдов пока нет";
    }

    if (!slides.length) {
      heroList.innerHTML = `
        <p class="admin-panel__empty p3">Добавьте первый слайд героя — он появится вверху главной страницы.</p>
      `;
      return;
    }

    heroList.innerHTML = slides.map((item, index) => `
      <article class="admin-panel__leader-card">
        <div class="admin-panel__leader-photo">
          <img src="${store.escapeHtml(store.resolveSlideImage(item, index))}" alt="" width="72" height="72" />
        </div>
        <div class="admin-panel__leader-body">
          <h4 class="admin-panel__leader-name h5">${store.escapeHtml(item.title.replace(/\*/g, ""))}</h4>
          <p class="admin-panel__leader-short p3">${store.escapeHtml(item.buttonText)}</p>
        </div>
        <div class="admin-panel__leader-actions">
          <button class="admin-panel__action-btn" type="button" data-hero-edit="${store.escapeHtml(item.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-hero-delete="${store.escapeHtml(item.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function clearClientsErrors() {
    document.querySelectorAll("[data-clients-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-clients-error]");
      if (error) error.hidden = true;
    });
    const titleField = document.querySelector("[data-home-clients-title-field]");
    if (titleField) {
      titleField.classList.remove("has-error");
      const error = titleField.querySelector("[data-home-clients-title-error]");
      if (error) error.hidden = true;
    }
  }

  function showClientsError(name) {
    const field = document.querySelector(`[data-clients-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-clients-error]");
    if (error) error.hidden = false;
  }

  function updateClientsImagePreview(src) {
    if (!clientsImagePreview) return;
    const img = clientsImagePreview.querySelector("img");
    if (!src) {
      clientsImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    clientsImagePreview.hidden = false;
  }

  function closeClientsModal() {
    if (clientsModal) clientsModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingClientId = null;
    if (clientsForm) clientsForm.reset();
    if (clientsImageData) clientsImageData.value = "";
    if (clientsImageInput) clientsImageInput.value = "";
    clearClientsErrors();
    updateClientsImagePreview("");
  }

  function openClientsModal() {
    if (!clientsModal) return;
    clientsModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function fillClientsTitleForm() {
    if (!homeClientsTitleInput) return;
    const clients = store.getHomeData().clients || store.getDefaultClients();
    homeClientsTitleInput.value = clients.title || "";
    if (homeClientsTitleNote) homeClientsTitleNote.hidden = true;
    clearClientsErrors();
  }

  function fillClientsForm(item) {
    if (!clientsForm) return;
    clientsForm.elements.id.value = item?.id || "";
    clientsForm.elements.alt.value = item?.alt || "Логотип";
    if (clientsImageData) clientsImageData.value = item?.image || "";
    updateClientsImagePreview(item ? store.resolveClientImage(item, 0) : "");
  }

  function renderClientsAdmin() {
    if (!clientsList) return;
    const clients = store.getHomeData().clients || store.getDefaultClients();
    const items = clients.items || [];

    if (clientsCount) {
      clientsCount.textContent = items.length
        ? `Логотипов: ${items.length}`
        : "Логотипов пока нет";
    }

    if (!items.length) {
      clientsList.innerHTML = `
        <p class="admin-panel__empty p3">Добавьте логотипы клиентов — они появятся в бегущей строке на главной.</p>
      `;
      return;
    }

    clientsList.innerHTML = items.map((item, index) => `
      <article class="admin-panel__leader-card">
        <div class="admin-panel__leader-photo">
          <img src="${store.escapeHtml(store.resolveClientImage(item, index))}" alt="" width="72" height="72" />
        </div>
        <div class="admin-panel__leader-body">
          <h4 class="admin-panel__leader-name h5">${store.escapeHtml(item.alt || "Логотип")}</h4>
          <p class="admin-panel__leader-short p3">Клиент ${index + 1}</p>
        </div>
        <div class="admin-panel__leader-actions">
          <button class="admin-panel__action-btn" type="button" data-clients-edit="${store.escapeHtml(item.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-clients-delete="${store.escapeHtml(item.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function clearApproachErrors() {
    document.querySelectorAll("[data-approach-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-approach-error]");
      if (error) error.hidden = true;
    });
    const titleField = document.querySelector("[data-home-approach-title-field]");
    if (titleField) {
      titleField.classList.remove("has-error");
      const error = titleField.querySelector("[data-home-approach-title-error]");
      if (error) error.hidden = true;
    }
  }

  function showApproachError(name) {
    const field = document.querySelector(`[data-approach-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-approach-error]");
    if (error) error.hidden = false;
  }

  function updateApproachIconPreview(src) {
    if (!approachIconPreview) return;
    const img = approachIconPreview.querySelector("img");
    if (!src) {
      approachIconPreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    approachIconPreview.hidden = false;
  }

  function closeApproachModal() {
    if (approachModal) approachModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingApproachId = null;
    if (approachForm) approachForm.reset();
    if (approachIconData) approachIconData.value = "";
    if (approachIconInput) approachIconInput.value = "";
    clearApproachErrors();
    updateApproachIconPreview("");
  }

  function openApproachModal() {
    if (!approachModal) return;
    approachModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function fillApproachTitleForm() {
    const approach = store.getHomeData().approach || store.getDefaultApproach();
    const parts = parseStarTitle(approach.title || store.DEFAULT_APPROACH_TITLE);
    if (homeApproachAccentInput) homeApproachAccentInput.value = parts.accent;
    if (homeApproachRestInput) homeApproachRestInput.value = parts.rest;
    if (homeApproachTitleNote) homeApproachTitleNote.hidden = true;
    clearApproachErrors();
    updateApproachTitlePreview();
  }

  function fillApproachForm(item) {
    if (!approachForm) return;
    approachForm.elements.id.value = item?.id || "";
    approachForm.elements.title.value = item?.title || "";
    approachForm.elements.text.value = item?.text || "";
    if (approachIconData) approachIconData.value = item?.icon || "";
    updateApproachIconPreview(item ? store.resolveApproachIcon(item, 0) : "");
  }

  function renderApproachAdmin() {
    if (!approachList) return;
    const approach = store.getHomeData().approach || store.getDefaultApproach();
    const items = approach.items || [];

    if (approachCount) {
      approachCount.textContent = items.length
        ? `Карточек: ${items.length}`
        : "Карточек пока нет";
    }

    if (!items.length) {
      approachList.innerHTML = `
        <p class="admin-panel__empty p3">Добавьте карточки подхода — они появятся в блоке «Наш подход к работе».</p>
      `;
      return;
    }

    approachList.innerHTML = items.map((item, index) => `
      <article class="admin-panel__leader-card">
        <div class="admin-panel__leader-photo">
          <img src="${store.escapeHtml(store.resolveApproachIcon(item, index))}" alt="" width="72" height="72" />
        </div>
        <div class="admin-panel__leader-body">
          <h4 class="admin-panel__leader-name h5">${store.escapeHtml(item.title)}</h4>
          <p class="admin-panel__leader-short p3">${store.escapeHtml(item.text.slice(0, 90))}${item.text.length > 90 ? "…" : ""}</p>
        </div>
        <div class="admin-panel__leader-actions">
          <button class="admin-panel__action-btn" type="button" data-approach-edit="${store.escapeHtml(item.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-approach-delete="${store.escapeHtml(item.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function showHomeEditor() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    const articlesEditor = document.querySelector('[data-content-editor="articles"]');
    const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = false;
    fillHomeDescriptionForm();
    fillHomeAchievementsForm();
    fillClientsTitleForm();
    fillApproachTitleForm();
    renderHeroAdmin();
    renderClientsAdmin();
    renderApproachAdmin();
    closeHeroModal();
    closeClientsModal();
    closeApproachModal();
  }

  function openCreateHero() {
    editingHeroId = null;
    if (heroFormTitle) heroFormTitle.textContent = "Новый слайд";
    fillHeroForm(null);
    if (heroImageData) heroImageData.value = "";
    updateHeroImagePreview("");
    clearHeroErrors();
    openHeroModal();
  }

  function openEditHero(id) {
    const slide = store.getHomeData().slides.find((item) => item.id === id);
    if (!slide) return;
    editingHeroId = id;
    if (heroFormTitle) heroFormTitle.textContent = "Редактирование слайда";
    fillHeroForm(slide);
    clearHeroErrors();
    openHeroModal();
  }

  function deleteHero(id) {
    const data = store.getHomeData();
    const item = data.slides.find((entry) => entry.id === id);
    if (!item) return;

    const label = item.title.replace(/\*/g, "").slice(0, 60);
    const confirmed = window.confirm(`Удалить слайд «${label}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.slides = data.slides.filter((entry) => entry.id !== id);
    store.saveHomeData(data);
    renderHeroAdmin();
  }

  function handleHomeDescSubmit(event) {
    event.preventDefault();
    clearHomeDescErrors();

    const data = store.getHomeData();
    data.description = {
      title: String(homeDescForm.elements.title.value || "").trim(),
      paragraph1: String(homeDescForm.elements.paragraph1.value || "").trim(),
      paragraph2: String(homeDescForm.elements.paragraph2.value || "").trim(),
    };

    let hasError = false;
    if (!data.description.title) {
      showHomeDescError("title");
      hasError = true;
    }
    if (!data.description.paragraph1) {
      showHomeDescError("paragraph1");
      hasError = true;
    }
    if (!data.description.paragraph2) {
      showHomeDescError("paragraph2");
      hasError = true;
    }
    if (hasError) return;

    store.saveHomeData(data);
    showNote(homeDescNote);
  }

  function handleHomeAchievementsSubmit(event) {
    event.preventDefault();
    const data = store.getHomeData();
    data.achievements = [0, 1, 2].map((index) => ({
      value: String(homeAchievementsForm.elements[`value${index}`]?.value || "").trim(),
      label: String(homeAchievementsForm.elements[`label${index}`]?.value || "").trim(),
    }));
    store.saveHomeData(data);
    showNote(homeAchievementsNote);
  }

  function handleHeroSubmit(event) {
    event.preventDefault();
    clearHeroErrors();

    const formData = new FormData(heroForm);
    const payload = store.normalizeSlide({
      id: editingHeroId || store.createId(),
      title: formData.get("title"),
      buttonText: formData.get("buttonText") || "Заказать рекламу",
      image: heroImageData?.value || "",
      imageIndex: store.getHomeData().slides.length % (store.DEFAULT_HERO_IMAGES?.length || 3),
    });

    if (editingHeroId) {
      const existing = store.getHomeData().slides.find((item) => item.id === editingHeroId);
      if (existing) payload.imageIndex = existing.imageIndex;
    }

    if (!payload.title) {
      showHeroError("title");
      return;
    }

    const data = store.getHomeData();
    const index = data.slides.findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.slides[index] = payload;
    } else {
      data.slides.push(payload);
    }

    store.saveHomeData(data);
    closeHeroModal();
    renderHeroAdmin();
  }

  function openCreateClient() {
    editingClientId = null;
    if (clientsFormTitle) clientsFormTitle.textContent = "Новый логотип";
    fillClientsForm(null);
    if (clientsImageData) clientsImageData.value = "";
    updateClientsImagePreview("");
    clearClientsErrors();
    openClientsModal();
  }

  function openEditClient(id) {
    const clients = store.getHomeData().clients || store.getDefaultClients();
    const item = (clients.items || []).find((entry) => entry.id === id);
    if (!item) return;
    editingClientId = id;
    if (clientsFormTitle) clientsFormTitle.textContent = "Редактирование логотипа";
    fillClientsForm(item);
    clearClientsErrors();
    openClientsModal();
  }

  function deleteClient(id) {
    const data = store.getHomeData();
    if (!data.clients) data.clients = store.getDefaultClients();
    const item = (data.clients.items || []).find((entry) => entry.id === id);
    if (!item) return;

    const confirmed = window.confirm(`Удалить логотип «${item.alt || "клиент"}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.clients.items = data.clients.items.filter((entry) => entry.id !== id);
    store.saveHomeData(data);
    renderClientsAdmin();
  }

  function handleClientsTitleSubmit(event) {
    event.preventDefault();
    clearClientsErrors();
    const title = String(homeClientsTitleInput?.value || "").trim();
    const titleField = document.querySelector("[data-home-clients-title-field]");
    if (!title) {
      if (titleField) {
        titleField.classList.add("has-error");
        const error = titleField.querySelector("[data-home-clients-title-error]");
        if (error) error.hidden = false;
      }
      return;
    }

    const data = store.getHomeData();
    data.clients = store.normalizeClients({
      ...(data.clients || store.getDefaultClients()),
      title,
    });
    store.saveHomeData(data);
    showNote(homeClientsTitleNote);
  }

  function handleClientsSubmit(event) {
    event.preventDefault();
    clearClientsErrors();

    const formData = new FormData(clientsForm);
    const image = String(clientsImageData?.value || "").trim();
    const existing = editingClientId
      ? (store.getHomeData().clients?.items || []).find((item) => item.id === editingClientId)
      : null;

    const payload = store.normalizeClientItem({
      id: editingClientId || store.createId(),
      alt: formData.get("alt") || "Логотип",
      image: image || existing?.image || "",
      imageIndex: existing?.imageIndex
        ?? ((store.getHomeData().clients?.items || []).length % (store.DEFAULT_CLIENT_IMAGES?.length || 7)),
    });

    if (!editingClientId && !payload.image) {
      showClientsError("image");
      return;
    }

    if (!store.resolveClientImage(payload)) {
      showClientsError("image");
      return;
    }

    const data = store.getHomeData();
    data.clients = store.normalizeClients(data.clients || store.getDefaultClients());
    const index = data.clients.items.findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.clients.items[index] = payload;
    } else {
      data.clients.items.push(payload);
    }

    store.saveHomeData(data);
    closeClientsModal();
    renderClientsAdmin();
  }

  function openCreateApproach() {
    editingApproachId = null;
    if (approachFormTitle) approachFormTitle.textContent = "Новая карточка";
    fillApproachForm(null);
    if (approachIconData) approachIconData.value = "";
    updateApproachIconPreview("");
    clearApproachErrors();
    openApproachModal();
  }

  function openEditApproach(id) {
    const approach = store.getHomeData().approach || store.getDefaultApproach();
    const item = (approach.items || []).find((entry) => entry.id === id);
    if (!item) return;
    editingApproachId = id;
    if (approachFormTitle) approachFormTitle.textContent = "Редактирование карточки";
    fillApproachForm(item);
    clearApproachErrors();
    openApproachModal();
  }

  function deleteApproach(id) {
    const data = store.getHomeData();
    if (!data.approach) data.approach = store.getDefaultApproach();
    const item = (data.approach.items || []).find((entry) => entry.id === id);
    if (!item) return;

    const confirmed = window.confirm(`Удалить карточку «${item.title}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.approach.items = data.approach.items.filter((entry) => entry.id !== id);
    store.saveHomeData(data);
    renderApproachAdmin();
  }

  function handleApproachTitleSubmit(event) {
    event.preventDefault();
    clearApproachErrors();
    const accent = String(homeApproachAccentInput?.value || "").trim();
    const rest = String(homeApproachRestInput?.value || "").trim();
    const titleField = document.querySelector("[data-home-approach-title-field]");
    if (!accent) {
      if (titleField) {
        titleField.classList.add("has-error");
        const error = titleField.querySelector("[data-home-approach-title-error]");
        if (error) error.hidden = false;
      }
      return;
    }

    const data = store.getHomeData();
    data.approach = store.normalizeApproach({
      ...(data.approach || store.getDefaultApproach()),
      title: buildStarTitle(accent, rest),
    });
    store.saveHomeData(data);
    showNote(homeApproachTitleNote);
  }

  function handleApproachSubmit(event) {
    event.preventDefault();
    clearApproachErrors();

    const formData = new FormData(approachForm);
    const existing = editingApproachId
      ? (store.getHomeData().approach?.items || []).find((item) => item.id === editingApproachId)
      : null;

    const payload = store.normalizeApproachItem({
      id: editingApproachId || store.createId(),
      title: formData.get("title"),
      text: formData.get("text"),
      icon: String(approachIconData?.value || "").trim() || existing?.icon || "",
      iconIndex: existing?.iconIndex
        ?? ((store.getHomeData().approach?.items || []).length % (store.DEFAULT_APPROACH_ICONS?.length || 6)),
    });

    let hasError = false;
    if (!payload.title) {
      showApproachError("title");
      hasError = true;
    }
    if (!payload.text) {
      showApproachError("text");
      hasError = true;
    }
    if (hasError) return;

    const data = store.getHomeData();
    data.approach = store.normalizeApproach(data.approach || store.getDefaultApproach());
    const index = data.approach.items.findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.approach.items[index] = payload;
    } else {
      data.approach.items.push(payload);
    }

    store.saveHomeData(data);
    closeApproachModal();
    renderApproachAdmin();
  }

  document.querySelectorAll('[data-content-open="home"]').forEach((button) => {
    button.addEventListener("click", showHomeEditor);
  });

  if (homeDescForm) {
    homeDescForm.addEventListener("submit", handleHomeDescSubmit);
    homeDescForm.querySelectorAll("[data-home-input]").forEach((input) => {
      input.addEventListener("input", () => {
        const field = input.closest("[data-home-field]");
        if (field) {
          field.classList.remove("has-error");
          const error = field.querySelector("[data-home-error]");
          if (error) error.hidden = true;
        }
        updateHomeDescFieldsUI();
      });
    });
  }

  if (homeAchievementsForm) {
    homeAchievementsForm.addEventListener("submit", handleHomeAchievementsSubmit);
  }

  if (heroCreateBtn) {
    heroCreateBtn.addEventListener("click", openCreateHero);
  }

  if (heroForm) {
    heroForm.addEventListener("submit", handleHeroSubmit);
  }

  document.querySelectorAll("[data-hero-modal-close]").forEach((element) => {
    element.addEventListener("click", closeHeroModal);
  });

  if (heroList) {
    heroList.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-hero-edit]");
      const deleteBtn = event.target.closest("[data-hero-delete]");
      if (editBtn) openEditHero(editBtn.getAttribute("data-hero-edit"));
      if (deleteBtn) deleteHero(deleteBtn.getAttribute("data-hero-delete"));
    });
  }

  if (heroImageInput) {
    heroImageInput.addEventListener("change", () => {
      const file = heroImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (heroImageData) heroImageData.value = result;
        updateHeroImagePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (heroImageReset) {
    heroImageReset.addEventListener("click", () => {
      if (heroImageData) heroImageData.value = "";
      if (heroImageInput) heroImageInput.value = "";
      updateHeroImagePreview("");
    });
  }

  if (homeClientsTitleForm) {
    homeClientsTitleForm.addEventListener("submit", handleClientsTitleSubmit);
  }

  if (clientsCreateBtn) {
    clientsCreateBtn.addEventListener("click", openCreateClient);
  }

  if (clientsForm) {
    clientsForm.addEventListener("submit", handleClientsSubmit);
  }

  document.querySelectorAll("[data-clients-modal-close]").forEach((element) => {
    element.addEventListener("click", closeClientsModal);
  });

  if (clientsList) {
    clientsList.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-clients-edit]");
      const deleteBtn = event.target.closest("[data-clients-delete]");
      if (editBtn) openEditClient(editBtn.getAttribute("data-clients-edit"));
      if (deleteBtn) deleteClient(deleteBtn.getAttribute("data-clients-delete"));
    });
  }

  if (clientsImageInput) {
    clientsImageInput.addEventListener("change", () => {
      const file = clientsImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (clientsImageData) clientsImageData.value = result;
        updateClientsImagePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (clientsImageReset) {
    clientsImageReset.addEventListener("click", () => {
      if (clientsImageData) clientsImageData.value = "";
      if (clientsImageInput) clientsImageInput.value = "";
      updateClientsImagePreview("");
    });
  }

  if (homeApproachTitleForm) {
    homeApproachTitleForm.addEventListener("submit", handleApproachTitleSubmit);
    [homeApproachAccentInput, homeApproachRestInput].forEach((input) => {
      input?.addEventListener("input", () => {
        clearApproachErrors();
        updateApproachTitlePreview();
      });
    });
  }

  if (approachCreateBtn) {
    approachCreateBtn.addEventListener("click", openCreateApproach);
  }

  if (approachForm) {
    approachForm.addEventListener("submit", handleApproachSubmit);
  }

  document.querySelectorAll("[data-approach-modal-close]").forEach((element) => {
    element.addEventListener("click", closeApproachModal);
  });

  if (approachList) {
    approachList.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-approach-edit]");
      const deleteBtn = event.target.closest("[data-approach-delete]");
      if (editBtn) openEditApproach(editBtn.getAttribute("data-approach-edit"));
      if (deleteBtn) deleteApproach(deleteBtn.getAttribute("data-approach-delete"));
    });
  }

  if (approachIconInput) {
    approachIconInput.addEventListener("change", () => {
      const file = approachIconInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (approachIconData) approachIconData.value = result;
        updateApproachIconPreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (approachIconReset) {
    approachIconReset.addEventListener("click", () => {
      if (approachIconData) approachIconData.value = "";
      if (approachIconInput) approachIconInput.value = "";
      updateApproachIconPreview("");
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (heroModal && !heroModal.hidden) closeHeroModal();
    if (clientsModal && !clientsModal.hidden) closeClientsModal();
    if (approachModal && !approachModal.hidden) closeApproachModal();
  });

  window.NMAdminHomeContent = {
    showHomeEditor,
    renderHeroAdmin,
    renderClientsAdmin,
    renderApproachAdmin,
    closeHeroModal,
    closeClientsModal,
    closeApproachModal,
  };
}

if (adminRoot) {
  initAdminHomeContent();
  window.setTimeout(initAdminHomeContent, 0);
}
